import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Download, Trash2 } from "lucide-react";
import AdminLayout from "../components/AdminLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminNewsletter() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/admin/newsletter`, { withCredentials: true });
      setSubs(data.subscribers || []);
    } catch { toast.error("Chargement impossible"); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const exportCSV = () => {
    // Uses cookie auth — window.open opens in same origin session
    window.location.href = `${API}/admin/newsletter/export`;
  };

  const del = async (email) => {
    if (!window.confirm(`Retirer ${email} de la liste ?`)) return;
    try {
      await axios.delete(`${API}/admin/newsletter/${encodeURIComponent(email)}`, { withCredentials: true });
      setSubs((prev) => prev.filter((s) => s.email !== email));
      toast.success("Retiré");
    } catch { toast.error("Action impossible"); }
  };

  return (
    <AdminLayout current="newsletter">
      <div className="max-w-4xl" data-testid="admin-newsletter-page">
        <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
          <div>
            <p className="label-caps text-[color:var(--gold)] text-[10px] tracking-[0.3em] mb-2">Marketing</p>
            <h1 className="font-serif text-4xl">Newsletter</h1>
            <p className="text-white/50 text-sm mt-2">{subs.length} abonné{subs.length > 1 ? "s" : ""}</p>
          </div>
          <button data-testid="export-csv"
            onClick={exportCSV}
            className="inline-flex items-center gap-2 bg-[color:var(--gold)] text-black hover:bg-white px-5 py-3 label-caps text-[11px] tracking-[0.25em] transition-colors">
            <Download size={14} /> Exporter CSV
          </button>
        </div>

        {loading && <p className="text-white/40">Chargement…</p>}
        {!loading && subs.length === 0 && (
          <div className="text-center py-20 border border-dashed border-white/10"><p className="text-white/50">Aucun abonné pour le moment.</p></div>
        )}

        <div className="border border-white/10">
          {subs.map((s, i) => (
            <div key={s.email} className={`flex items-center justify-between px-5 py-3 ${i > 0 ? "border-t border-white/5" : ""} hover:bg-white/5 transition-colors`} data-testid={`sub-${i}`}>
              <div className="flex items-center gap-4 min-w-0">
                <Mail size={14} className="text-[color:var(--gold)]" strokeWidth={1.5} />
                <div className="min-w-0">
                  <p className="text-white truncate">{s.email}</p>
                  <p className="text-white/40 text-xs">{s.created_at && new Date(s.created_at).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" })}</p>
                </div>
              </div>
              <button onClick={() => del(s.email)} className="text-white/30 hover:text-red-400 p-2 transition-colors" data-testid={`del-sub-${i}`}>
                <Trash2 size={14} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
